var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 89.5,
    y: 0.5,
    width: 89,
    height: 89,
    rx: 3.5,
    transform: "rotate(90 89.5 0.5)",
    stroke: "black",
    strokeOpacity: 0.45
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(5px)",
      clipPath: "url(#bgblur_0_1424_8_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 10
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82.5,
    y: 7.5,
    width: 75,
    height: 75,
    rx: 4,
    transform: "rotate(90 82.5 7.5)",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1424_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.7728 35.1368L24.9691 37.9872C24.5116 38.0959 24.3236 38.644 24.6175 39.0104L35.1603 52.0526L39.7728 35.1368ZM28.4645 35.1951L39.6556 32.5304L37.9195 25.5872C37.859 25.3454 37.5583 25.2622 37.3822 25.4383L28.1633 34.6572C27.9351 34.8854 28.1497 35.2698 28.4645 35.1951ZM22.9533 41.9339L28.9973 57.9052C29.1587 58.344 29.721 58.4669 30.0511 58.1368L33.7696 54.4183L23.5065 41.6298C23.2829 41.3495 22.8372 41.5936 22.9533 41.9339ZM42.1488 31.9364L54.7685 28.3685C55.414 28.2145 55.4287 27.3017 54.7889 27.1273L40.6658 24.1716C40.4342 24.1234 40.2326 24.3341 40.2892 24.5628L42.1488 31.9364ZM49.5297 40.4702L55.7136 46.654L59.8358 31.7076C59.9462 31.2428 59.7927 30.8017 59.4955 30.5044C59.1982 30.2071 58.7571 30.0537 58.2922 30.1641L43.3458 34.2863L49.5297 40.4702ZM64.4127 52.0803L57.4689 50.3448L54.8042 61.5359C54.7289 61.8502 55.1139 62.0653 55.3427 61.8366L64.5616 52.6177C64.7377 52.4416 64.6545 52.1409 64.4127 52.0803ZM58.0635 47.8511L65.4376 49.71C65.6669 49.7672 65.877 49.5651 65.8288 49.3335L62.8725 35.211C62.6981 34.5711 61.7853 34.5858 61.6313 35.2313L58.0635 47.8511ZM48.37 66.4933L35.5821 56.2297L31.8636 59.9482C31.5329 60.2789 31.6564 60.8406 32.0952 61.0019L48.0665 67.046C48.4063 67.1626 48.6503 66.717 48.37 66.4933ZM54.8631 50.227L37.9479 54.8401L50.99 65.3829C51.3569 65.6762 51.9045 65.4888 52.0132 65.0313L54.8631 50.227ZM47.7177 42.2821L42.031 36.5954L37.7661 52.2338L53.4045 47.9689L47.7177 42.2821Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_1424_8_clip_path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82.5,
    y: 7.5,
    width: 75,
    height: 75,
    rx: 4,
    transform: "rotate(90 82.5 7.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1424_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    fill: "white",
    transform: "translate(45 16.0087) rotate(45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBlack);
export default __webpack_public_path__ + "static/media/hero_black.8d3188c89c9e80744f8dbb6b4eb777ee.svg";
export { ForwardRef as ReactComponent };